import { render, staticRenderFns } from "./PaginaAdminMunicipios.vue?vue&type=template&id=2dc4e16d&lang=es"
import script from "./PaginaAdminMunicipios.vue?vue&type=script&lang=js"
export * from "./PaginaAdminMunicipios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports